import FormField from './FormField';
import FormWrapper from './FormWrapper';
import AwsCredentialsSection from './AwsCredentialsSection';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import ConnectionTestButton from './ConnectionTestButton';
import type { FieldConfig } from './types';
import type { S3Config } from '../../types';
import { transformS3ConfigForTest } from '../../utils/connectionConfigTransformers';
import { useConnectionTest } from '../../hooks/useConnectionTest';

const bucketFields: FieldConfig[] = [
    {
        name: 'bucketName',
        label: 'Bucket Name',
        type: 'text',
        required: true,
        placeholder: 'my-data-bucket',
    },
];

const additionalFields: FieldConfig[] = [
    {
        name: 'prefix',
        label: 'Prefix (Optional)',
        type: 'text',
        placeholder: 'data/',
        extra: 'Path within the bucket to search for files',
    },
];

interface S3ConfigFormProps {
    onConnectionTestSuccess?: () => void;
}

export default function S3ConfigForm({ onConnectionTestSuccess }: S3ConfigFormProps) {
    const { getConfig, handleTestConnection, isLoading } = useConnectionTest<S3Config>(
        transformS3ConfigForTest,
        config => Boolean(config?.bucketName && config?.accessKeyId && config?.secretAccessKey && config?.region),
        onConnectionTestSuccess
    );

    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            {bucketFields.map(field => (
                <FormField
                    key={Array.isArray(field.name) ? field.name.join('.') : field.name}
                    config={field}
                />
            ))}
            <AwsCredentialsSection />
            {additionalFields.map(field => (
                <FormField
                    key={Array.isArray(field.name) ? field.name.join('.') : field.name}
                    config={field}
                />
            ))}
            {onConnectionTestSuccess && (
                <ConnectionTestButton
                    getConfig={getConfig}
                    testConnection={handleTestConnection}
                    isLoading={isLoading}
                />
            )}
        </FormWrapper>
    );
}
